import { OptionInterface } from '../../shared/interfaces/common.interface';

export const weightUnits :OptionInterface[] = [
  { label: 'lbs', value: 'pounds' },
  { label: 'oz', value: 'ounces' },
];

export const dimensionUnits :OptionInterface[] = [
  { label: 'in', value: 'inches' },
  { label: 'cm', value: 'centimeters' },
];
